import React, { useEffect, useRef, useState } from 'react';

import { AppBar, Button, Container, Grid, IconButton, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack, ArrowBackIos } from '@material-ui/icons';

import User from '../../models/User';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: 'bold',
  },
  mainContainer: {
    padding: '30px',
  },
  submitContainer: {
    paddingTop: theme.spacing(4),
  },
  title: {
    color: '#172B4D',
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23px',
  },
  toolbar: {
    padding: 0,
  },
}));

export default ({ data, onEdit, onClose, title, buttonText, validation, fields, errorsStream }) => {
  const defaultData = data || new User();
  const classes = useStyles();
  const dataFields = useRef();
  const [validationErrors, setValidationErrors] = useState({});
  const onEditClick = () => {
    const validData = dataFields.current.getValidData();
    if (validData) {
      onEdit(validData);
    }
  };

  useEffect(() => {
    if (data) {
      dataFields.current.setFormData(data);
    }
  }, [data]);

  useEffect(() => {
    let errorSub;
    if (errorsStream) {
      errorSub = errorsStream.subscribe(setValidationErrors);
    }
    return () => {
      if (errorSub) {
        errorSub.unsubscribe();
      }
    };
  }, [errorsStream]);

  return (
    <Container maxWidth="xs" className={classes.mainContainer}>
      <AppBar position="static" color="transparent">
        <Toolbar variant="dense" className={classes.toolbar}>
          <IconButton edge="start" color="primary" onClick={onClose}>
            <ArrowBackIos />
          </IconButton>
          <Typography variant="h5" align="left" className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <EditFields
        validationErrors={validationErrors}
        fields={fields}
        data={defaultData}
        labelPosition="top"
        labelClass={classes.bold}
        validate={validation}
        useAutoFocus={false}
        ref={dataFields}
      />

      <Grid container className={classes.submitContainer}>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={onEditClick}>
            {buttonText}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
